<template lang="pug">
  .auth--forgot
    .text--center
      h3.no-margin {{ $t('auth.messages.forgotPassword.title') }}
      p {{ $t('auth.messages.forgotPassword.message') }}

    form.auth__form(@submit.prevent="checkForm")
      //- Email input
      input(
        type="email"
        name="email"
        v-model="email"
        v-validate="'required|email'"
        :data-vv-as="$t('auth.form.email')"
        :class="{'error': errors.has('email') }"
        :placeholder="$t('auth.form.email')")

      //- Errores de validación del formulario
      .margin-halve-top
        .auth__error(v-show="errors.has('email')") {{ errors.first('email') }}

      //- Botón enviar
      van-button(
        size="large"
        type="primary"
        native-type="submit") {{ $t('auth.form.send')}}

    hr.auth__hr

    //- Enlaces a otras páginas
    .text--center.margin-top
      router-link.auth__link(to="/auth/login") {{ $t('auth.goToLogin')}}
</template>

<script>
import i18n from '@/locales/i18n';
import { getErrorId } from '@/services/error.service';
import UserService from '@/services/user.service';

export default {
  data() {
    return {
      email: '',
      authError: null,
      isLoading: false,
    };
  },
  methods: {
    /**
     * Compruebo si los datos del formulario son válidos
     */
    checkForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.forgotUser();
        }
      });
    },

    /*
     * Send email a user with info to set a new password
     */
    async forgotUser() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;
        this.authError = null;

        // Realizo la petición
        await UserService.forgot(this.email);

        this.$toast.clear();

        this.$dialog
          .alert({
            title: i18n.t('auth.messages.resetPassword.title'),
            message: i18n.t('auth.messages.resetPassword.message'),
          })
          .then(() => this.$router.push({ name: 'login' }));
      } catch (error) {
        // Obtengo el error
        this.authError = getErrorId(error);

        this.$toast.clear();

        // Si el usuario no ha confirmado su cuenta,
        // muestro un modal para que pueda volver a recibir el email de confirmación.
        // si el usuario no existe, muestro el error en la vista
        // en cualquier otro caso, muestro un error por defecto
        if (this.authError === 'userNotConfirmed') {
          this.$dialog
            .confirm({
              title: i18n.t(`auth.messages.notValidate.title`),
              message: i18n.t(`auth.messages.notValidate.message`),
            })
            .then(() => this.sendConfirmEmail());
        } else if (this.authError === 'userNotExist') {
          this.$toast.fail({
            mask: true,
            message: i18n.t(`auth.messages.userNotExist`),
          });
        } else {
          this.$toast.fail({
            mask: true,
            message: i18n.t('general.errors.default.message'),
          });
        }

        // this.forgot(user)
        //   .then(() => {
        //     this.$dialog
        //       .alert({
        //         title: i18n.t('auth.messages.resendToken.title'),
        //         message: i18n.t('auth.messages.resendToken.message'),
        //       })
        //       .then(() => this.$router.push('/auth/login'));
        //   })
        //   .catch(error => {
        //     /*
        //      * Check if error is by email not confirmed
        //      * and
        //      */
        //     if (
        //       error &&
        //       error.response &&
        //       error.response.data &&
        //       error.response.data._id === 'userNotConfirmed'
        //     ) {
        //       this.notVerifiedEmail(error);
        //     } else {
        //       this.getErrorIds(error, {
        //         component: 'src/views/auth/Login.vue',
        //         method: 'login',
        //         data: user,
        //       });
        //     }
        //   })
        //   .finally(() => this.$toast.clear());
        //   }
        // });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Vuelve a enviar el email de confirmación al usuario
     */
    async sendConfirmEmail() {
      try {
        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Realizo la petición
        await UserService.sendConfirmEmail(this.email);

        // Quito el loader y Confirmo el envío del email
        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: i18n.t('auth.messages.resendToken'),
        });
      } catch (error) {
        // Ocurrió algún error,
        // quito el loader y muestro un mensaje de error
        this.$toast.clear();
        this.$toast.fail({
          mask: true,
          message: i18n.t('general.errors.default.message'),
        });
      }
    },
  },
  created() {
    window.scrollTo(0, 0);
  },
};
</script>
